export const STATUS_LABELS: any = {
    ACTIVE: 'cop.helper.status.active',
    READY_FOR_CONSULTATION_PROCESS: 'cop.helper.status.ready-for-consultation-process',
    IN_THE_CONSULTING_PROCESS: 'cop.helper.status.in-the-consulting-process',
};

export const STATUS_DESCRIPTIONS: any = {
    ACTIVE: 'cop.helper.status-description.active',
    READY_FOR_CONSULTATION_PROCESS:
        'cop.helper.status-description.ready-for-consultation-process',
    IN_THE_CONSULTING_PROCESS: 'cop.helper.status-description.in-the-consulting-process',
};